import { Token } from 'models';
import { Validation } from './validation';

export const validationService = new Validation();

export const isLogged = () => {
  const token = Token.get();
  return Boolean(token);
};

export const scriptExist = (src) => {
  return !!document.querySelector(`script[src='${src}']`);
};

export const loadScript = (src) => {
  if (scriptExist(src)) return Promise.resolve();
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.type = 'text/javascript';
    script.addEventListener('load', () => resolve());
    script.addEventListener('error', e => reject(e));
    document.body.appendChild(script);
  });
};

export const formatDate = (date, format = 'YYYY-MM-DD') => {
  const newDate = new Date(date);
  if (!date) return '';
  if (!Date.parse(newDate)) return 'Invalid Date';

  const year = String(newDate.getFullYear());
  let month = String((newDate.getMonth() + 1));
  let day = String(newDate.getDate());
  let returnDate;

  if (month.length < 2) month = `0${month}`;
  if (day.length < 2) day = `0${day}`;

  if (format === 'MM/DD/YYYY') {
    returnDate = [month, day, year].join('/');
  } else if (format === 'YYYY') {
    returnDate = year;
  } else if (format === 'DD/MM/YYYY') {
    returnDate = [day, month, year].join('/');
  } else if (format === 'dd/mm/yyyy hh:mm:ss') {
    returnDate = newDate.toLocaleString();
  } else {
    returnDate = [year, month, day].join('-');
  }

  return returnDate;
};

export const addBuildInfo = () => {
  const firstBodyElement = document.body.firstChild;
  const gitCommit = (process.env.REACT_APP_COMMIT || '').substring(0, 6);
  const lastModifiedComment = document.createComment(`
    @at: ${process.env.REACT_APP_BUILT_AT}
    @hash: ${gitCommit}
    @version: ${process.env.REACT_APP_VERSION}
    @env: ${process.env.REACT_APP_ENV}
  `);

  if (document.body) document.body.insertBefore(lastModifiedComment, firstBodyElement);
};

export const getMailtoUrl = (to, subject, body) => {
  const args = [];
  if (typeof subject !== 'undefined') {
    args.push(`subject=${encodeURIComponent(subject)}`);
  }
  if (typeof body !== 'undefined') {
    args.push(`body=${encodeURIComponent(body)}`);
  }

  let url = `mailto:${encodeURIComponent(to)}`;
  if (args.length > 0) {
    url += `?${args.join('&')}`;
  }
  return url;
};

export function formatBaseLink(url) {
  const match = url.match(/.+console\/users/);
  if (match && match[0]) return removeTrailingSlash(match[0]);
  return url;
}

export function removeFirstSlash(url) {
  return url.replace(/^\//, '');
}

export function removeTrailingSlash(url) {
  return url.replace(/\/$/, '');
}

export function formatDetailsLink(baseLink, params) {
  const { asset_id, viewId } = params;

  if (asset_id) baseLink = `${baseLink}/${asset_id}`;
  if (viewId) baseLink = `${baseLink}/${viewId}`;

  return baseLink;
}

export const createOutsideClickListener = (element, action) => event => {
  if (!element.contains(event.target)) action();
};


/* eslint-disable no-bitwise */
export const hexToRGBA = (hex, opacity = 1) => {
  try {
    let c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      c = hex.substring(1).split('');
      if (c.length === 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c = `0x${c.join('')}`;
      return `rgba(${[(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',')},${opacity})`;
    }
    throw new Error('Bad Hex');
  } catch (error) {
    console.log('hexToRgbA', error);
    return hex;
  }
};
/* eslint-enable no-bitwise */



// WEBPACK FOOTER //
// ./src/utils/index.js